module.exports = function() {
	return [
		"a",
		"an",
		"the",
		"my",
		"her",
		"his",
		"their",
		"its",
		"our",
		"your",
	];
};



// WEBPACK FOOTER //
// ./node_modules/yoastseo/js/researches/english/passivevoice/determiners.js